import * as React from 'react'
import { Footer, Banner, PageBackground } from 'shared-components'
import NavBarWrapper from '../NavbarWrapper/NavbarWrapper'
import LinkComponent from '../LinkComponent/LinkComponent'
import '@boxicons/core/fonts/basic/boxicons.min.css'
import '@boxicons/core/fonts/filled/boxicons-filled.min.css'
import '@boxicons/core/fonts/brands/boxicons-brands.min.css'

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <NavBarWrapper />
      <Banner />
      <PageBackground>
        {children}
        <Footer LinkComponent={LinkComponent} />
      </PageBackground>
    </>
  )
}

export default Layout
